import classNames from 'classnames'
import debounce from 'lodash/debounce'
import find from 'lodash/find'
import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as ab from '../../store/ab'
import * as addToLookActions from '../../actions/addToLook'
import * as looks from '../../store/looks'
import * as pdp from '../../store/productDetailPage'
import * as track from '../../track/other'

import Experiment from '../Pieces/Experiment'

const AddToLookDropdown = ({
  addProductToLook,
  addRecommendedProductsToLook,
  allNonHtoLooks,
  isOpen,
  origin,
  modifier,
  productSlug,
  isCTL,
}) => (
  <ul
    className={classNames('pdp-atl-dropdown', {
      'is--open': isOpen,
      [`pdp-atl-dropdown--${modifier}`]: modifier,
    })}
  >
    {allNonHtoLooks.map(({id, name, products}) => (
      <li key={id} className={classNames('pdp-atl-dropdown-item mod--existing-look', id)}>
        <button
          onClick={() => {
            if (isCTL) {
              return debounce(addRecommendedProductsToLook, 300)(id, origin)
            }
            return debounce(addProductToLook, 300)(id, origin)
          }}
        >
          {name}
          {modifier
            ? find(products, {slug: productSlug}) && (
                <span className="pdp-revamp">Already In Look</span>
              )
            : find(products, {slug: productSlug}) && <span className="checkmark">✓</span>}
        </button>
      </li>
    ))}
    <Experiment test={ab.LOOKBUILDER_PDP_ENTRYPOINT}>
      <li className="pdp-atl-dropdown-item mod--new-look">
        <button
          onClick={() => {
            if (isCTL) {
              addRecommendedProductsToLook(null, origin)
            }
            track.clickedLink({
              location: 'pdp',
              text: 'Add To A New Look',
              type: 'button',
            })
            addProductToLook(null, origin)
          }}
        >
          + add to a new look
        </button>
      </li>
    </Experiment>
  </ul>
)

AddToLookDropdown.propTypes = {
  addProductToLook: PropTypes.func.isRequired,
  addRecommendedProductsToLook: PropTypes.func.isRequired,
  allNonHtoLooks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isCTL: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  origin: PropTypes.string,
  modifier: PropTypes.string,
  productSlug: PropTypes.string.isRequired,
}

AddToLookDropdown.defaultProps = {
  productSlug: '',
}

const mapStateToProps = createStructuredSelector({
  allNonHtoLooks: looks.getNonHtoLooks,
  productSlug: pdp.productSlug,
})

const mapDispatchToProps = {
  addProductToLook: addToLookActions.addProductToLook,
  addRecommendedProductsToLook: addToLookActions.addRecommendedProductsToLook,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToLookDropdown)
